/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Diet_BodyInputs */

const en_portal_diet_body = /** @type {(inputs: Portal_Diet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach sets the meal plan and the target for the day. You photograph your plate, and the app recognises the food and adds its calories and macros.`)
};

const pl_portal_diet_body = /** @type {(inputs: Portal_Diet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener ustawia jadłospis i cel na dzień. Ty fotografujesz talerz, a aplikacja rozpoznaje jedzenie i dolicza kalorie oraz makro.`)
};

/**
* | output |
* | --- |
* | "Your coach sets the meal plan and the target for the day. You photograph your plate, and the app recognises the food and adds its calories and macros." |
*
* @param {Portal_Diet_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_diet_body = /** @type {((inputs?: Portal_Diet_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Diet_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_diet_body(inputs)
	return en_portal_diet_body(inputs)
});